// src/Components/Admin/AdminProtectedRoute.js
import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';

function AdminProtectedRoute() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Check if user is authenticated (you can implement your own auth logic)
    const checkAuth = async () => {
      // Example: Check for admin token in localStorage
      const adminToken = localStorage.getItem('admin_token');
      if (adminToken) {
        // You can also verify the token with your backend
        setIsAuthenticated(true);
      }
      setLoading(false);
    };
    
    checkAuth();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Redirect to login page or show unauthorized message
    return <Navigate to="/admin-login" state={{ from: location }} replace />;
  }

  return <AdminDashboard />;
}

export default AdminProtectedRoute;